import Vue from 'vue'
import Vuex from 'vuex'

import { getLang, setLang } from '../utils/lang'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    lang: getLang(),
  },
  mutations: {
    changeLang (state, lang) {
      state.lang = lang
      setLang(lang)
    }
  },
  getters: {
    currentLang: state => state.lang
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js